import * as React from 'react';

export interface IDashboardTabContext {
	activeTab?: string;
}

export const DashboardTabContext = React.createContext<IDashboardTabContext>(
	{}
);
